<template>
  <div class="footer-pro has-text-centered">
    <img class="" src="/img/winnicotti_brasilia_logo.png" style="width:80px;opacity: 0.5">
    <br />
    <a href="https://www.facebook.com/espacowinnicottbrasilia" target="_blank">
      <i class="fab fa-facebook"></i>/EspacoWinicottBrasilia
    </a>
    <br />
    <div class="is-small" style="margin-top:50px; margin-left:5px; font-size:12px">&copy; 2018</div>
    <small style="margin-left:5px; font-size:12px">by  <a href="https://www.linkedin.com/in/helder-de-sousa">Helder de Sousa</a></small>
  </div>
</template>

<script>

export default {
  name: 'Index',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-pro{
  margin-top: 100px;
  margin-bottom: 50px;
}

</style>
